export type WorkflowStep = 'write' | 'analyze' | 'review' | 'rehearse' | 'generate' | 'complete';

export interface WorkflowStepInput {
  rawContent: string;
  hasAnalyzedSections: boolean;
  sectionsStale: boolean;
  sectionsAccepted: boolean;
  hasRehearsal: boolean;
  rehearsalSkipped: boolean;
  generationActive: boolean;
  musicGenerated: boolean;
}

export function deriveWorkflowStep(input: WorkflowStepInput): WorkflowStep {
  if (!input.rawContent.trim()) return 'write';
  if (!input.hasAnalyzedSections || input.sectionsStale) return 'analyze';
  const implicitlyAccepted = input.hasRehearsal || input.rehearsalSkipped || input.musicGenerated;
  if (!input.sectionsAccepted && !implicitlyAccepted) return 'review';
  if (!input.hasRehearsal && !input.rehearsalSkipped) return 'rehearse';
  if (input.generationActive) return 'generate';
  if (input.musicGenerated) return 'complete';
  return 'generate';
}
